import React from 'react';
import styled from 'styled-components';

import {
  red,
  blue,
  green,
  white,
  cobalt,
  exactWhite,
} from 'utils/style/colors';

import Icon from 'components/Icon';
import IconTypes from 'components/Icon/IconTypes';
import { Spinner } from '../Button/style';
import { PopoverPlacement } from '../PopoverBase/types';

interface IHoverIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  type: IconTypes;
  color: Colors;
  size?: string;
  loading?: boolean;
  title?: any;
  titleClick?: boolean;
  titlePlacement?: PopoverPlacement;
}

type Colors = 'blue' | 'red' | 'green' | 'white' | 'cobalt' | string;

const setColor = {
  red,
  blue,
  green,
  white,
  cobalt,
};

const Span = styled('span')<Exclude<IHoverIconProps, 'type'>>`
  color: ${(props) => setColor[props.color] || props.color};
  cursor: pointer;
  display: inline-flex;
  padding: 2px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-weight: 500;
  border-radius: 18px;

  &:hover {
    color: ${(props) => (props.color === 'white' ? cobalt : white)};
    background-color: ${(props) => setColor[props.color] || props.color};
  }

  & > i {
    font-size: ${(props) => props.size || '16px'};
    margin-right: 0;
  }

  & > i:hover {
    color: ${exactWhite} !important;
  }
`;

const HoverIcon: React.FC<IHoverIconProps> = ({
  type,
  color,
  size,
  loading,
  titleClick,
  titlePlacement,
  ...restProps
}) => {
  return (
    <Span color={color} {...restProps} size={size}>
      {loading ? (
        <Spinner color={color} viewBox="0 0 128 128">
          <path
            className="path"
            d="M75.4 126.6a11.4 11.4 0 0 1-2.1-22.6 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.3 4.9h0a63.8 63.8 0 0 1-47.8 48.1v0a11.4 11.4 0 0 1-2.9z"
          />
        </Spinner>
      ) : (
        <Icon
          type={type}
          title={restProps?.title}
          titleClick={titleClick}
          titlePlacement={titlePlacement}
        />
      )}
    </Span>
  );
};

export default React.memo(HoverIcon);
